import React, { useEffect, useState } from "react";

// Calculate "feels like" temperature using Wind Chill if temp <= 50°F
function calculateFeelsLike(tempF, windStr) {
  const match = windStr.match(/\d+/);
  const windMph = match ? parseInt(match[0]) : 0;

  if (tempF <= 50 && windMph > 3) {
    return Math.round(
      35.74 +
        0.6215 * tempF -
        35.75 * Math.pow(windMph, 0.16) +
        0.4275 * tempF * Math.pow(windMph, 0.16)
    );
  }

  return Math.round(tempF);
}

export default function HourlyWeatherCards({ lat, lon, neonColor = "rgba(66, 72, 66, 1)" }) {
  const [hours, setHours] = useState([]);

  useEffect(() => {
    async function fetchHourly() {
      try {
        const pointRes = await fetch(`https://api.weather.gov/points/${lat},${lon}`);
        const pointData = await pointRes.json();
        const hourlyUrl = pointData.properties.forecastHourly;

        const res = await fetch(hourlyUrl);
        const data = await res.json();
        const periods = data.properties.periods.slice(0, 10); // next 10 hours

        const cards = periods.map((p) => {
          const temp = p.temperature; // °F
          const feelsLike = calculateFeelsLike(temp, p.windSpeed);
          const forecastLower = (p.shortForecast || "").toLowerCase();
          const precipType = forecastLower.includes("snow")
            ? "Snow"
            : forecastLower.includes("rain")
            ? "Rain"
            : "Clear";

          return {
            time: p.startTime,
            temp,
            feelsLike,
            unit: p.temperatureUnit,
            precipType,
            icon: p.icon, // NWS icon URL
          };
        });

        setHours(cards);
      } catch (err) {
        console.error("Error fetching NWS hourly:", err);
      }
    }

    fetchHourly();

    // Auto-refresh every 3 hours
    const interval = setInterval(fetchHourly, 3 * 60 * 60 * 1000);
    return () => clearInterval(interval);
  }, [lat, lon]);

  return (
    <div
      style={{
        display: "flex",
        gap: "1rem",
        justifyContent: "center",
        flexWrap: "wrap",
        color: neonColor,
      }}
    >
      {hours.map((h, i) => {
        const date = new Date(h.time);
        const hour = date.getHours();
        const label = ` ${ hour % 12 || 12} ${ hour >= 12 ? "PM" : "AM"}`;

        return (
          <div
            key={i}
            style={{
              background: "#111",
              padding: "1rem",
              borderRadius: "10px",
              minWidth: "120px",
              textAlign: "center",
              boxShadow: `0 0 8px ${neonColor}, 0 0 16px ${neonColor}`,
            }}
          >
            <div style={{ fontSize: "3rem", fontWeight: "bold" }}>{label}</div>
            
            <div style={{ fontSize: "3rem" }}>
              {h.temp}°{h.unit}
            </div>
            <div style={{ fontSize: "1.5rem" }}>Feels {h.feelsLike}°</div>
            <div style={{ fontSize: "1.5rem", marginTop: "0.2rem" }}>{h.precipType}</div>
          </div>
        );
      })}
    </div>
  );
}
